import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push as changeURL } from 'react-router-redux';
import isEmpty from 'lodash/isEmpty';
import _ from 'lodash/string';

import mapDispatch from '~/misc/mapDispatch';
import { getUrlQeury } from '~/misc/formatUrlquery';
import { getPaymentInfosAction } from '~/modules/hp/actions';
import Spinner from '~/components/common/Spinner';
import { track } from '~/misc/metrics';
import {
  saveAccountAction,
  billInfoAction,
  getPaymentInfoAction,
  payOrderAction,
} from '~/pages/Payment/apis/payment.js';
import { modalChange } from '~/modules/modal/actions';
import * as modals from '~/modules/modal/modes';
import EndingPage from '~/components/pages/EndingPage';
import BillingOptions from './components/PaymentOptions';
import {
  saveOrderInfoAction,
  savePayInfoAction,
  saveOrderStatusAction,
  setOrderLoadingStatusAction,
} from '~/modules/payment/actions';
import { getLastBillingInfoAction } from './apis/billing';

import css from './style.css';

const membershipMap = {
  standard: 'essential',
  premium: 'preferred',
  professional: 'ultimate',
  essential: 'standard',
  preferred: 'premium',
  ultimate: 'professional',
  free: 'free',
};

const membershipLevel = {
  standard: 2,
  premium: 3,
  professional: 4,
  essential: 2,
  preferred: 3,
  ultimate: 4,
  free: 4,
};

//  payment of per week change
// f**k foolish
class ManagePlans extends Component {
  constructor(props) {
    super(props);
    const { premiumInfo } = props.user;
    const accountBillingCycle =
      premiumInfo && premiumInfo.billCycle
        ? premiumInfo.billCycle === 'Free'
          ? 'monthly'
          : premiumInfo.billCycle
        : 'monthly';
    this.state = {
      loading: true,
      accountBillingCycle: accountBillingCycle.toLowerCase(),
      selectedBill: {},
      nowMembershipPlan: '',
      originBillings: {},
      upgradeLevel: 0,
      userId: (props.user && props.user.id) || 0,
      accountLevel: props.account.accountLevel,
    };
  }
  setLevel() {
    const query = getUrlQeury();
    if (!isEmpty(query) && query.from) {
      track('payment', { source: query.from });
    }
    const { accountLevel } = this.props.account;
    let newLevel = accountLevel;
    if (!isEmpty(query) && query.level) {
      const queryLevel = membershipLevel[query.level] || 0;
      // membership package will show grater than upgradelevel so we need 'queryLevel - 1'
      newLevel = Math.max(queryLevel - 1, accountLevel);
    }
    this.setState({ upgradeLevel: newLevel });
    // const level = query.level || 'preferred';
  }
  setBillings() {
    const promisGetPaymentInfos = this.props.getPaymentInfos({
      platform: 'customer',
      gradeOptionKey: 'standard,premium,professional',
    });
    const promisUserBillingInfo = this.props.getLastBillingInfo();
    Promise.all([promisGetPaymentInfos, promisUserBillingInfo]).then(values => {
      const billingPackages = values[0];
      const accountLastBillingInfo = values[1];
      const { seat_num } = accountLastBillingInfo.data;
      const formatBillings = this.formatBillings(billingPackages.data, {
        seat_num: (seat_num && seat_num) || 1,
      });
      this.setState({
        loading: false,
        billings: formatBillings,
        originBillings: billingPackages.data,
        accountLastBillingInfo: accountLastBillingInfo.data,
        seat_num,
      });
    });
  }
  componentDidMount() {
    if (!this.state.userId) return;
    this.setLevel();
    this.setBillings();
  }
  componentWillReceiveProps(nextProps) {
    const token = window.localStorage.getItem('sessionToken');
    if (!token) {
      this.props.goToHomePage();
      return;
    }
    if (
      nextProps &&
      nextProps.user &&
      nextProps.user.id &&
      nextProps.user.id !== this.state.userId &&
      nextProps.user.premiumInfo &&
      nextProps.account &&
      nextProps.account.accountLevel &&
      nextProps.account.accountLevel !== this.state.accountLevel
    ) {
      const { premiumInfo } = nextProps.user;
      const accountBillingCycle =
        premiumInfo && premiumInfo.billCycle
          ? premiumInfo.billCycle === 'Free'
            ? 'monthly'
            : premiumInfo.billCycle
          : 'monthly';
      this.setState({
        userId: nextProps.user.id,
        accountLevel: nextProps.account.accountLevel,
        accountBillingCycle: accountBillingCycle.toLowerCase(),
      });
      this.setLevel();
      this.setBillings();
    }
  }
  componentWillUnmount() {
    const { saveOrderInfo, savePayInfo, saveOrderStatus, setOrderLoadingStatus } = this.props;
    // reset order status on destory

    saveOrderInfo(null);
    savePayInfo(null);
    saveOrderStatus('NOT_FINISH_YET');
    setOrderLoadingStatus(false);
  }
  accountLevelToDesc(accountLevel) {
    const memberShip = {
      1: 'Free',
      2: 'Essential',
      3: 'Preferred',
      4: 'Ultimate',
    };
    return memberShip[accountLevel];
  }
  formatBillings(data, { seat_num }) {
    if (!data || !Array.isArray(data) || data.length === 0) return [];
    const { premiumInfo } = this.props.user;
    const accountLevel = this.state.upgradeLevel;
    const essential = {
      featuresText: '4 Features',
      priceTag: '',
    };
    const preferred = {
      featuresText: '7 Features',
      priceTag: 'MOST POPULAR',
    };
    const ultimate = {
      featuresText: '13 Features',
      priceTag: 'BEST VALUE',
    };
    data.forEach(item => {
      item.discount_price = item.discount_price * seat_num;
      const nameArr = item.key.split('_');
      const key = item.grade_name.toLowerCase();
      const billingType = nameArr[nameArr.length - 1];
      const billingCycleType = nameArr.splice(0, nameArr.length - 1).join('');
      const tempItem = { ...item };
      // const currentBillingCycle = (premiumInfo && premiumInfo.billCycle) || 'Monthly';
      if (membershipMap[billingType] === 'essential') {
        essential[billingCycleType] = tempItem;
        essential.showCurrent = accountLevel < 2;
      }
      if (membershipMap[billingType] === 'preferred') {
        preferred[billingCycleType] = tempItem;
        preferred.showCurrent = accountLevel < 3;
      }
      if (membershipMap[billingType] === 'ultimate') {
        ultimate[billingCycleType] = tempItem;
        // ultimate.showCurrent = currentBillingCycle.toLowerCase() === 'monthly' || accountLevel < 4;
        // Always show ultimate
        ultimate.showCurrent = true;
      }
    });
    return [essential, preferred, ultimate];
  }
  openModal(paymentType) {
    const { isLoggedIn } = this.props.user;
    const { accountLevel } = this.props.account;
    const nowMembershipPlan = this.accountLevelToDesc(accountLevel);
    const {
      loading,
      accountBillingCycle,
      billings,
      originBillings,
      accountLastBillingInfo,
      seat_num,
    } = this.state;

    // Do check current user is logined in or not first

    if (isLoggedIn) {
      // if logined in
      this.props.showMembershipsModal({
        paymentType,
        accountBillingCycle,
        billings,
        nowMembershipPlan,
        originBillings,
        accountLastBillingInfo,
        seat_num,
      });
    } else {
      this.props.showLogIn();
    }
    const eventName = paymentType === 'Annually' ? 'change_to_annual' : 'purchase_next';
    const query = getUrlQeury();
    if (!isEmpty(query) && query.from) {
      track(eventName, { source: query.from });
    }
  }
  render() {
    const { user, account, payment } = this.props;
    const { isLoggedIn, premiumInfo } = user;
    const { accountLevel } = this.props.account;
    const upgradeAccountLevel = this.state.upgradeLevel;
    const { loading, accountBillingCycle, billings } = this.state;
    const { orderInfo, payInfo, orderStatus, orderLoading } = payment;
    const { platform } = premiumInfo || {};

    const isUltimateAnnual =
      upgradeAccountLevel === 4 && (premiumInfo.billCycle || '').toLowerCase() === 'annually';
    let footerShow = isLoggedIn && !isUltimateAnnual;
    return (
      <section className={css.membershipPlansSection}>
        {orderStatus !== 'successful' && orderStatus !== 'failure' && !orderLoading && (
          <div className={`${css.membershipPlans} ${css.membershipPlansNoPadding}`}>
            <header>Membership Plans</header>
            {!loading && (
              <main>
                {billings && (
                  <BillingOptions billings={billings} accountBillingCycle={accountBillingCycle} />
                )}

                {(platform && platform.toLowerCase() === 'android') ||
                (platform && platform.toLowerCase() === 'ios') ? (
                  <footer>
                    <div className={css.cantUpgrade}>
                      Please upgrade your membership on the Truckloads APP
                    </div>
                  </footer>
                ) : (
                  footerShow && (
                    <footer>
                      <div className={css.selectedBillingInfo}>
                        Current Membership:{' '}
                        <span className={css.content}>
                          {_.upperFirst(
                            membershipMap[(premiumInfo.memberPlan || 'Free').toLowerCase()]
                          )}
                        </span>
                        {premiumInfo.memberPlan.toLowerCase() !== 'free' && (
                          <span>
                            <span className={css.divider}>|</span>
                            Billing cycle:{' '}
                            <span className={css.content}>{_.upperFirst(accountBillingCycle)}</span>
                          </span>
                        )}
                      </div>
                      {accountBillingCycle === 'monthly' && accountLevel < 4 && accountLevel > 1 && (
                        <div
                          className={css.upgradeToAnnual}
                          onClick={() => this.openModal('Annually')}>
                          Change to an Annual Plan and save 2 months on membership fees
                        </div>
                      )}
                      <div className={css.buttons}>
                        <button onClick={() => this.openModal()}>
                          {accountLevel === 1 ? 'Next' : 'Upgrade'}
                        </button>
                      </div>
                    </footer>
                  )
                )}
              </main>
            )}
            {loading && (
              <div className={css.membershipLoading}>
                <Spinner scalable={true} />
              </div>
            )}
          </div>
        )}
        {(orderStatus !== 'successful' || orderStatus !== 'failure') && orderLoading && (
          <div className={css.orderLoadingContainer}>
            <div className={css.blackLayer}></div>
            <div className={css.simplePaymentLoading}>
              <Spinner scalable={true} />
            </div>
          </div>
        )}
        {(orderStatus == 'successful' || orderStatus == 'failure') && (
          <div className={css.payResult}>
            <EndingPage
              user={user}
              account={account}
              orderInfo={orderInfo}
              payInfo={payInfo}
              type={
                (orderStatus == 'successful' && 'result') || (orderStatus == 'failure' && 'pending')
              }
            />
          </div>
        )}
      </section>
    );
  }
}

export default connect(
  ({ user, account, payment }) => ({ user, account, payment }),
  mapDispatch({
    getPaymentInfos: (_, options) => getPaymentInfosAction(options),
    saveAccount: (_, params) => saveAccountAction(params),
    billInfo: (_, params) => billInfoAction(params),
    getPaymentInfo: (_, params) => getPaymentInfoAction(params),
    getLastBillingInfo: (_, params) => getLastBillingInfoAction(params),
    showMembershipsModal: (_, params) => {
      return modalChange(modals.MEMBERSHIP_PLANS, params);
    },
    showLogIn: () => modalChange('login', 'rate-check'),
    saveOrderInfo: (_, params) => saveOrderInfoAction(params),
    savePayInfo: (_, params) => savePayInfoAction(params),
    saveOrderStatus: (_, params) => saveOrderStatusAction(params),
    setOrderLoadingStatus: (_, params) => setOrderLoadingStatusAction(params),
    goToHomePage: () => changeURL('/'),
  })
)(ManagePlans);



// WEBPACK FOOTER //
// ./src/pages/MembershipPlans/index.js